export default "__VITE_ASSET__$Xvt_xpm__"